<template>
    <el-dialog
        :visible.sync="dialogFlag"
        width="20%"
        top="15%"
        :close-on-press-escape="false"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div slot="title" class="header-title">
           <span>成绩作废原因</span>
        </div>
        <div class="reasonContent">{{reason}}
        </div>  
        <div slot="footer" class="dialog-footer">
          <el-button  @click="showHideCancelScoreDialog(false)">关 闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
  export default {
    data() {
      return {
        dialogFlag: false,
        reason:''

      };
    },
    props:{
      value:Boolean,
      studentId:String
    },
    watch:{
      value:async function(){
        if(this.value){
          this.dialogFlag=this.value
          await this.getReason()

            
        }
      },
    },
    methods:{
      showHideCancelScoreDialog: function(flag){
        this.dialogFlag = flag
        this.$emit('cancel') 
      },
      getReason:function(){
        let params={
          reExamOrderId:this.studentId,
        }
        this.$http.get(`/examination/reason/invalidate`,{ params} ).then((res) => {
          if (res.data.success) {
            this.reason=res.data.data.invalidateReason
          } 
        }) 
      },
    }   
  };
</script>
<style scoped>
.header-title{
    padding: 20px 0 0 0;
    font-size: 34px;
    font-weight:bold;
    text-align: center; 
}
::v-deep  .el-dialog__body {
  padding: 20px 30px 0 30px;
  font-size: 16px;
}
::v-deep .el-dialog__footer{
    width: 100%;
    padding: 0;
    margin-top:50px;
    border-top: 2px solid #EDEDED;
    
}
.dialog-footer{
  width: 100%;
  display:flex;
  height: 120px;
}

.dialog-footer /deep/ .el-button{
  margin: 0;
    padding: 0;
    width: 100%;
    border-radius: 0;
    border: none;
    border-right: 2px solid #EDEDED;
    font-size: 16px;
}
.reasonContent{
  white-space: pre-wrap;
}
</style>